/*global VeloxWebView*/


/**
 * Extension to search cities in ZIP Codes
 */
var extension = {} ;
extension.name = "electrolyzer-field" ;

//must run after fields
extension.mustRunAfter = ["fields", "country"] ;

var COUNTRY_AVAILABILITY = {
    "SALT_RELAX" :       { FR: true, DE: true, ES: true, GB: true}, 
    "SALT_RELAX_PRO" :   { FR: true, DE: true, ES: true, GB: true}, 
    "SALT_RELAX_PLUS" :  { FR: true, DE: false,ES: true, GB: true}, 
    "SALT_RELAX_POWER" : { FR: true, DE: false,ES: true, GB: true}  
};


function computeOptions(){
    return Object.keys(COUNTRY_AVAILABILITY).filter(function(p){
        //filter by country availability
        return COUNTRY_AVAILABILITY[p][VeloxWebView.country.get()] ;
    }).concat(["OTHER"]).map(function(p){
        return {
            id: p,
            label: VeloxWebView.tr("fields.values.pool.p_electrolyzer."+p)
        } ;
    }) ;
}

extension.init = function(){
    var view = this ;
    view.on("initDone", function(){
        var electEl = view.viewRootEl.querySelector('[data-field-def="pool.p_electrolyzer"]');
        var saltRateEl = view.viewRootEl.querySelector('[data-field-def="pool.p_disinf_salt_rate"]');
        if(!electEl){
            electEl = view.viewRootEl.querySelector('[data-field-def="diag.p_electrolyzer"]');
            saltRateEl = view.viewRootEl.querySelector('[data-field-def="diag.p_disinf_salt_rate"]');
        }
        if(electEl && saltRateEl){
            function onChange(){
                var elect = electEl.getValue() ;
                if(elect === "SALT_RELAX"){
                    saltRateEl.setValue(3.5) ;
                }else if(elect === "SALT_RELAX_PRO"){
                    saltRateEl.setValue(2) ;
                }else if(elect === "SALT_RELAX_PLUS"){
                    saltRateEl.setValue(3.5) ;
                }else if(elect === "SALT_RELAX_POWER"){
                    saltRateEl.setValue(2) ;
                }else{
                    saltRateEl.setValue("") ;
                }
            }
            electEl.addEventListener("change", onChange) ;
            view.on("render", function(){
                electEl.setOptions(computeOptions()) ;
            }) ;
        }   

    }) ;
} ;




module.exports = extension ;